import { render, staticRenderFns } from "./MainButtonDecorLeft.vue?vue&type=template&id=6352f6e1"
import script from "./MainButtonDecorLeft.vue?vue&type=script&lang=js"
export * from "./MainButtonDecorLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports